import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { fetchSubscription } from '../../services/subscriptions';

function useGetSubscription() {
  const { user } = useUser();

  const enabled = !!user && !!user?.business?.id;

  const query = useQuery({
    queryKey: ['subscription', user?.userId, user?.business?.id],
    queryFn: async () => {
      const data = await fetchSubscription(user?.business?.id!);
      return data;
    },
    enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isFetching: query.isFetching,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
}

export default useGetSubscription;
